/**
 * Backoffice Service API Client
 *
 * Axios instance configured for Backoffice Service
 * Handles backoffice-specific operations for ALC dashboard
 */

import { API_CONFIG } from '../config';
import { createApiClient } from './api-client-factory';

/**
 * Backoffice API Client
 * Handles backoffice book management and review operations
 */
const backofficeClient = createApiClient({
  baseURL: API_CONFIG.BACKOFFICE.BASE_URL,
  timeout: API_CONFIG.BACKOFFICE.TIMEOUT,
  withRefreshToken: false, // TODO: Enable when backend supports refresh token
  refreshEndpoint: '/auth/refresh',
});

export default backofficeClient;
